<template>
  <div>

<!--    <div class="jumbotron-container bg-gradient">
      <div class="jumbotron jumbotron-fluid jumbotron-select text-white py-6">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 mb-5 mb-md-0"><img class="img-fluid w-75"
                src="data:image/svg+xml;base64,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">
            </div>
            <div class="col-12 col-md-6 align-self-center">
              <h3 class="text-white font-weight-normal mb-2">{{ __('lang.heliosselect.jumbotron.h3')}}</h3>
              <h4 class="text-white font-weight-light">{{ __('lang.heliosselect.jumbotron.h4') }}</h4>
              <h4 class="text-white font-weight-light"> {{ __('lang.heliosselect.jumbotron.h4_2') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>-->
   <section class="bg-gray-10 py-2">
      <div class="container">
        <div class="col-12 text-center">
          <p class="small mb-0"><a class="text-secondary stretched-link collapsed" data-toggle="collapse"
              href="#infobox" role="button" aria-expanded="false" aria-controls="infobox">{{
              __('lang.heliosselect.jumbotron.infobox.title')}}<span class="text-primary d-block">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></a></p>
        </div>
        <div class="collapse" id="infobox">
          <div class="col-12 mt-3">
            <h2 class="text-primary mb-3">{{__('lang.heliosselect.jumbotron.infobox.h2')}}
            </h2>
            <p class="mb-5">{{__('lang.heliosselect.jumbotron.infobox.text')}}</p>
            <div class="row mb-3">
              <div class="col-12 col-sm-6">
                <h5>{{__('lang.heliosselect.jumbotron.infobox.h5_1')}}</h5>
                <ul class="list-unstyled square square-small">
                  <li class="mb-1">{{__('lang.heliosselect.jumbotron.infobox.h5_1_li1')}}
                  </li>
                  <li class="mb-1">{{__('lang.heliosselect.jumbotron.infobox.h5_1_li2')}}</li>
                  <li>{{__('lang.heliosselect.jumbotron.infobox.h5_1_li3')}}</li>
                </ul>
              </div>
              <div class="col-12 col-sm-6">
                <h5>{{__('lang.heliosselect.jumbotron.infobox.h5_2')}}</h5>
                <ul class="list-unstyled square square-small">
                  <li class="mb-1">{{__('lang.heliosselect.jumbotron.infobox.h5_2_li1')}}</li>
                  <li class="mb-1">{{__('lang.heliosselect.jumbotron.infobox.h5_2_li2')}}</li>
                  <li>{{__('lang.heliosselect.jumbotron.infobox.h5_2_li3')}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      <!--
    <div class="container pt-5">
       <configurationhead></configurationhead>
    </div>-->

    <div class="container pt-5 pb-7">
        <div class="row justify-content-center text-secondary">
          <div class="col-12">
            <ul class="nav nav-tabs nav-fill" role="tablist">
              <li class="nav-item ml-md-3" role="presentation"><a class="nav-link h4 text-gray-70 font-weight-light active"
                  id="category-nav-tab" data-toggle="tab" href="#category-tab-pane" role="tab" aria-controls="category-tab-pane"
                  aria-selected="true" @click="resetTabData">{{ __('lang.start.tab.configuration') }}</a></li>
              <li class="nav-item ml-3 ml-md-0" role="presentation"><a class="nav-link h4 text-gray-70 font-weight-light"
                  id="use-nav-tab" data-toggle="tab" href="#use-tab-pane" role="tab" aria-controls="use-tab-pane"
                  aria-selected="false"  @click="getActionareas">{{ __('lang.start.tab.actionareas') }}</a></li>
              <li class="nav-item ml-md-3" role="presentation"><a class="nav-link h4 text-gray-70 font-weight-light"
                  id="search-nav-tab" data-toggle="tab" href="#search-tab-pane" role="tab" aria-controls="search-tab-pane"
                  aria-selected="false"  @click="resetTabData">{{ __('lang.start.tab.directsearch') }}</a></li>
            </ul>
          </div>
          <div class="col-12">
            <div class="tab-content">
              <div class="tab-pane active" id="category-tab-pane">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8 py-5 text-center">
                    <h2 class="text-primary font-weight-thin mb-4">{{ __('lang.start.tab.configuration.yoursconfiguration') }}</h2>
                  </div>
                </div>
                <operatingpoint ref="operatingpoint" parentcontainer="category_tab"></operatingpoint>
              </div>
              <actionarea ref="actionarea"></actionarea>
              <directsearch ref="directsearch"></directsearch>
            </div>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import operatingpoint from './OperatingPoint'
import actionarea from './Actionarea'
import directsearch from './Directsearch'
import configurationhead from './ConfigurationHead'




    export default {
         components: {
          operatingpoint,
          actionarea,
          directsearch,
          configurationhead

        },
        computed:{


        },
        data() {
          return {


          }
        },
        methods: {
          resetTabData() {
            this.$refs.operatingpoint.resetOperatingPoint()
            this.$refs.actionarea.resetActionarea()
            this.$refs.directsearch.resetInputData()

          },
          getActionareas() {
            this.resetTabData()
            this.$refs.actionarea.resetActionarea()
            this.$refs.actionarea.getActionareas()

          }

        },
        mounted () {
        }
    }
</script>
